import { render, staticRenderFns } from "./CustomerOriginList.vue?vue&type=template&id=3648b806&"
import script from "./CustomerOriginList.vue?vue&type=script&lang=js&"
export * from "./CustomerOriginList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports